<template lang="html">
  <div>
    <div class="section-container">
      <div class="text-to-left">
        <div>
        <h2>Proven efficacy</h2>
        <p>10,000+ users. 89% user approval. 90% commitment to behaviour change.</p>
        </div>
      </div>
      <div class="image-right chart">
        &nbsp;
      </div>
    </div>

    <div class="section-container reverse-for-small">
      <div class="image-left brain">
        &nbsp;
      </div>
      <div class="text-to-right">
      <div>
        <h2>Five years in development</h2>
        <p>Developed with experts in the fields of neuroscience, psychology, and sociology.</p>
      </div>
      </div>
    </div>

    <div class="section-container">
      <div class="text-to-left">
      <div>
        <h2>Real footage</h2>
        <p>No actors. No made up scenarios. Recordings of real people in real situations.
        </p>
      </div>
      </div>
      <div class="image-right interview">
        &nbsp;
      </div>
    </div>

    <div class="section-container reverse-for-small">
      <div class="image-left funnel">
        &nbsp;
      </div>
      <div class="text-to-right">
      <div>
        <h2>Expert insights on ethnicity and social mobility bias</h2>
        <p>15 years’ expertise, ten original research reports, and hundreds of thousands of data points distilled into
          easily digested insights on bias in employment and education.</p>
      </div>
      </div>
    </div>

    <div class="section-container">
      <div class="text-to-left">
      <div>
        <h2>Practical tips and advice on how to combat bias in employment and education</h2>
        <p>Put your newly acquired knowledge into practice.</p>
      </div>
      </div>
      <div class="image-right bias">
        &nbsp;
      </div>
    </div>

    <div class="section-container reverse-for-small">
      <div class="image-left security">
        &nbsp;
      </div>
      <div class="text-to-right">
        <div>
          <h2>Totally private and secure</h2>
          <p>User responses permanently deleted after completion. World-class information security with ISO27001
            accreditation. A completely safe space for honest reflection.</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'HomeProductsHemisphereMainSection',
  props: {
  },
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container {
}

.section-container {
  display: flex;
  min-height: 450px;
}

.text-to-left, .text-to-right {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  width: 58%;
  padding: 0 10%;
}

.text-to-left h2, .text-to-right h2 {
  font-size: 56px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
}

.text-to-left p, .text-to-right p {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  margin: 10px 0 50px 0;
}

.text-to-left {
  background-color: $light-grey-background;
  color: $main-text
}

.text-to-right {
  background-color: #323C44;
  color: $white-text;
}

.image-left, .image-right {
  background-position: center center;
  background-size: cover;
  width: 42%;
  height: 450px;
}

@media only screen and (max-width: 800px) {
  .section-container {
    flex-direction: column;
    min-height: auto;
  }

  .reverse-for-small {
    flex-direction: column-reverse !important;
  }

  .text-to-left, .text-to-right {
    width: 100%;
    padding: 0 20px;
  }

  .text-to-left h2, .text-to-right h2 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.39;
    margin: 32px 0 0 0;
  }

  .text-to-left p, .text-to-right p {
    font-size: 18px;
    line-height: 1.43;
    letter-spacing: normal;
    margin: 20px 0 40px 0;
  }

  .image-left, .image-right {
    width: 100%;
    height: 240px;
  }

}

@media only screen and (min-width: 800px) {
  .text-to-left p:last-of-type, .text-to-right p:last-of-type {
    margin-bottom: 0;
  }
}

.chart {
  background-image: url('../../../../assets/img/hemisphereImages/chart.png');
}

.brain {
  background-image: url('../../../../assets/img/hemisphereImages/brian.png');
}

.interview {
  background-image: url('../../../../assets/img/hemisphereImages/interview.png');
}

.funnel {
  background-image: url('../../../../assets/img/hemisphereImages/funnel.png');
}

.bias {
  background-image: url('../../../../assets/img/hemisphereImages/bias.png')
}

.security {
  background-image: url('../../../../assets/img/hemisphereImages/security.png')
}
</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsHemisphere/components/homeProductsHemisphereMainSection.vue